import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import EdicaoProduto from './EdicaoProduto'
import PrimeTable from '../../../components/PrimeTable'

const ProdutoFluxoAtendimento = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dadosProduto, setDadosProduto] = useState(null)
  const [dadosLote, setDadosLote] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const handleRemove = useCallback((dados) => {
    metodoPrograma('exclui', { idProduto: dados[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const handleClick = (linha) => {
    setDadosProduto(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setTela(tela === 'opcoesLote' ? 'opcoes' : 'lista')
    tela !== 'opcoesLote' && setDadosProduto([])
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Grid>
            <Tooltip title="Voltar">
              <IconButton onClick={voltar}>
                <MdArrowBack />
              </IconButton>
            </Tooltip>
            <Tooltip title="Adicionar Lote">
              <IconButton onClick={() => setTela('opcoesLote')}>
                <MdAdd />
              </IconButton>
            </Tooltip>
          </Grid>,
        )
        break
      case 'opcoesLote':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break

      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlProduto" ferramentas={ferramentas}>
      {(() => {
        switch (tela) {
          case 'opcoes':
            return (
              <EdicaoProduto
                {...{ dadosProduto, voltar, setTela, dadosLote, setDadosLote }}
              />
            )
          default:
            return (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <PrimeTable
                    codigo="CtrlProduto"
                    action="lista"
                    rows={10}
                    habSearch
                    head={[
                      'Código',
                      'Produto',
                      'Estoque Mínimo',
                      'Controlado',
                      'Exclusão',
                      'Valor Venda',
                    ]}
                    line={(item) => [
                      item[1],
                      item[2],
                      item[6],
                      item[4] === 'S' ? 'Sim' : 'Não',
                      item[8],
                      item[5],
                    ]}
                    collumnsDateHour={[4]}
                    collumnsCurrency={[5]}
                    onRowSelect={handleClick}
                    onDelete={{ index: 8, action: handleRemove }}
                    refresh={refresh}
                  />
                </Grid>
              </Grid>
            )
        }
      })()}
    </Programa>
  )
}

export default ProdutoFluxoAtendimento
